import Image from "next/image";
import Link from "next/link";

import { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import style from "./style.module.scss";

type ProfileLogoProps = {
  profileURL: string;
  logoSrc: string;
  size?: string;
  isSquare: boolean;
  faFallbackLogo?: any;
};

const ProfileLogo = ({
  profileURL,
  logoSrc,
  size,
  isSquare,
  faFallbackLogo,
}: ProfileLogoProps) => {
  const compressSize = useMemo(() => {
    switch (size) {
      case "small":
        return 23;
      case "compact":
        return 33;
      default:
        return 53;
    }
  }, [size]);

  return (
    <Link href={profileURL} passHref>
      <div
        className={`${style.container} ${size && style[size]} ${
          isSquare && style.square
        }`}
      >
        {faFallbackLogo ? (
          <FontAwesomeIcon icon={faFallbackLogo} className="text-[30px]" />
        ) : (
          <Image
            key={logoSrc}
            src={logoSrc}
            alt="Logo"
            width={compressSize}
            height={compressSize}
            priority
            className={twMerge(!isSquare && "rounded-full")}
          />
        )}
      </div>
    </Link>
  );
};

export default ProfileLogo;
